/**
 * Get the appropriate dashboard route based on user roles
 * @param {Array} roles - Array of role objects with name property
 * @returns {string} Dashboard route path
 */
export const getDashboardRoute = (roles) => {
  if (!roles || roles.length === 0) {
    return '/profile'; // Default to profile for users without roles
  }

  const roleNames = roles.map((role) => role.name?.toUpperCase() || role.toUpperCase());

  // Admin gets highest priority
  if (roleNames.includes('ADMIN')) {
    return '/admin';
  }

  // Moderator gets second priority
  if (roleNames.includes('MODERATOR')) {
    return '/moderator';
  }

  // Default to profile for regular users
  return '/profile';
  
};
